import { useQuery } from "@tanstack/react-query";
import {
  type MerchantPersonCandidatesDto,
  getAuthMigrateMerchantCandidates,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const MERCHANT_PERSON_CANDIDATES_QUERY_KEY = "MIGRATE_MERCHANT_CANDIDATES";

export const merchantPersonCandidatesKeys = {
  all: [MERCHANT_PERSON_CANDIDATES_QUERY_KEY],
};

/**
 * Loads the company's statutory-body RelatedParties as candidates for the Merchant/Employee
 * create-identity migration flow. Caller's User.Party must be a LegalEntity. Returns 4xx if
 * the caller is not in a state where this picker applies.
 */
export const useGetMerchantPersonCandidatesQuery = () =>
  useQuery<MerchantPersonCandidatesDto>({
    queryKey: merchantPersonCandidatesKeys.all,
    queryFn: processResponseWithApiProblemDetails(() =>
      getAuthMigrateMerchantCandidates(),
    ),
  });
